import CargoCompanyOrderBillingsListRequest, {
  CargoCompanyOrderBillingsListQueryParams,
} from "./cargo-company-order-billings-list.request";

const createQueryParams = (
  request: CargoCompanyOrderBillingsListRequest,
): CargoCompanyOrderBillingsListQueryParams => {
  return {
    limit: request.limit,
    offset: request.offset,
    address: request.address,
    dateSince: request.dateSince,
    dateTo: request.dateTo,
    dispatch: request.dispatch,
    endAddress: request.endAddress,
    externalId: request.externalId,
    humanId: request.humanId,
    midAddress: request.midAddress,
    order: request.order,
    passenger: request.passenger,
    startAddress: request.startAddress,
    status: request.status,
    taxi: request.taxi,
  };
};

const cargoCompanyOrderBillingsListRequestFactory = {
  createQueryParams,
};

export default cargoCompanyOrderBillingsListRequestFactory;
